import { ILogsManager } from './logsManager.types';

export class ConsoleLogsManager implements ILogsManager {
  logDebug(message: string, data: any) {
    console.debug(message, data);
  }

  logInfo(message: string, data: any) {
    console.info(message, data);
  }

  logError(error: Error | string, data: any) {
    console.error(error, data);
  }

  logWarning(message: string, data: any) {
    console.warn(message, data);
  }
}
